import Icon from '../components/Icon.vue'

Icon.register({
  strikethrough: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 288h-480c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM281.3 304h122.8c6.5 14.2 10.1 30.8 10.1 50.6 0 89-73.4 134.4-162 134.4-76.8 0-154.5-35-154.5-101.8v-19.2c0-8.8 7.2-16 16-16h45.6c8.8 0 16 7.2 16 16v1.6c0 32.2 44.5 44.3 76.9 44.3 46.6 0 75.6-20.6 75.6-53.7 0-27.6-19.3-43.3-46.5-56.2zM250.4 208h-129.8c-8.1-15.4-12.8-33.8-12.8-56.5 0-84.7 65.5-125.6 150.7-125.6 70.9 0 142.6 27.4 142.6 79.9v30.3c0 8.8-7.2 16-16 16h-45.6c-8.8 0-16-7.2-16-16v-2.1c0-16.4-22.3-33-65-33-34.1 0-65 13.5-65 47.4 0 30.7 24.4 46.2 56.8 59.7z'
      }
    ]
  }
})
